import { render, staticRenderFns } from "./configuration_social_network_new_modal.vue?vue&type=template&id=1cc89acf"
import script from "./configuration_social_network_new_modal.vue?vue&type=script&lang=js"
export * from "./configuration_social_network_new_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports